import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ChatOptionList from '../ChatOptionList/ChatOptionList';
import DHPic from '../../images/Dr-haiel3.png';

const useStyles = makeStyles({
  root: {
    maxWidth: 345
  },
  media: {
    height: 140
  },
  divider: {
    background: '#1EB0BC'
  },
  avt: {
    marginBottom: 20,
    '&:before': {
      backgroundImage: `url(${DHPic})`,
      backgroundSize: '30px 30px',
      backgroundRepeat: 'no-repeat',
      content: '""',
      position: 'absolute',
      left: 10,
      width: 30,
      height: 30
    }
  },
  bot: {
    maxWidth: 345
  }
});

const QuestionCard = ({ title, option, onUserInput, isLastMessage }) => {
  // console.log('title', title);
  // console.log('option', option);
  // console.log('onUserInput', onUserInput);
  // console.log('isLastMessage', isLastMessage);
  const classes = useStyles();
  return (
    <Fragment>
      <div className={classes.avt}>_</div>
      <Card
        className={(classes.root, classes.bot)}
        style={{ marginBottom: '20px', backgroundColor: '#E3F5F7' }}
      >
        <CardContent>
          <Typography variant="h5" component="h2" style={{ fontSize: '1rem' }}>
            {' '}
            {title}{' '}
          </Typography>{' '}
        </CardContent>{' '}
        <CardActionArea>
          <Divider className={classes.divider} />{' '}
        </CardActionArea>{' '}
        <ChatOptionList
          type="button"
          options={option}
          onUserInput={onUserInput}
          isLastMessage={isLastMessage}
        />{' '}
        <CardActions />
      </Card>
    </Fragment>
  );
};
QuestionCard.propTypes = {
  title: PropTypes.string.isRequired,
  option: PropTypes.object.isRequired,
  onUserInput: PropTypes.func.isRequired,
  isLastMessage: PropTypes.bool.isRequired
};
QuestionCard.defaultProps = {
  isSelected: false
};

export default QuestionCard;



// WEBPACK FOOTER //
// ./src/components/QuestionCard/QuestionCard.js